import type { StatusToken } from "@lib/config/statusTokens";
import { AlertTriangle, Bug, Lightbulb, Users } from "lucide-react";

interface QuickFilter {
  id: string;
  label: string;
  icon: typeof Users;
  /** L2.5 semantic token — null keeps the neutral primary style. */
  token: StatusToken | null;
}

const QUICK_FILTERS: readonly QuickFilter[] = [
  { id: "all", label: "Tous", icon: Users, token: null },
  { id: "open", label: "Ouverts", icon: AlertTriangle, token: "pending" },
  {
    id: "proposition_solution",
    label: "Propositions",
    icon: Lightbulb,
    token: "awaiting-approval",
  },
  { id: "bug", label: "Bugs", icon: Bug, token: "rejected" },
];

interface TicketsQuickFiltersProps {
  active: string;
  onChange: (value: string) => void;
}

export function TicketsQuickFilters({ active, onChange }: TicketsQuickFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {QUICK_FILTERS.map((filter) => {
        const isActive = active === filter.id;
        const style = filter.token
          ? isActive
            ? {
                color: `var(--status-${filter.token})`,
                backgroundColor: `var(--status-${filter.token}-bg)`,
                borderColor: `color-mix(in oklab, var(--status-${filter.token}) 20%, transparent)`,
              }
            : {
                color: `var(--status-${filter.token})`,
                borderColor: `color-mix(in oklab, var(--status-${filter.token}) 35%, transparent)`,
              }
          : undefined;

        return (
          <button
            key={filter.id}
            type="button"
            className={`btn btn-sm gap-2 ${
              isActive ? (filter.token ? "" : "btn-primary") : "btn-outline"
            }`}
            style={style}
            onClick={() => onChange(filter.id)}
          >
            <filter.icon className="w-4 h-4" /> {filter.label}
          </button>
        );
      })}
    </div>
  );
}
